import { type FC } from "react";
import LinkOff from "@mui/icons-material/LinkOff";

import { InfoPage } from "../../../shared/components/info-page/info-page";
import { InfoPageIllustration } from "../../../shared/components/info-page/info-page-illustration";
import { InfoPageLayout } from "../../../shared/components/info-page/info-page-layout";
import { SignInButton } from "../components/sign-in-button";
import { SignOutButton } from "../components/sign-out-button";

export const RemoteFailurePage: FC = () => (
  <InfoPageLayout>
    <InfoPage
      title="Не удалось войти"
      message="Вход прервался. Попробуйте войти ещё раз"
      illustration={<InfoPageIllustration icon={LinkOff} />}
      actions={
        <>
          <SignOutButton />
          <SignInButton />
        </>
      }
    />
  </InfoPageLayout>
);
